export default __webpack_public_path__ + "static/media/telescope-a.06b6cb86.png";